import React, { forwardRef, ComponentProps } from 'react';
import { InputAdornment, TextField } from '@mui/material';

export type IPropsInput = {
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  dataTestId?: string;
} & ComponentProps<typeof TextField>;

export const StyledInput = (props: ComponentProps<typeof TextField>) => (
  <TextField
    color="primary"
    size="small"
    fullWidth={false}
    sx={theme => ({
      input: {
        '&:-webkit-autofill': {
          WebkitBoxShadow: `0 0 0 100px ${theme.palette.background.default} inset`,
          borderRadius: '0px'
        }
      },
      fieldset: {
        legend: {
          width: 'unset'
        }
      }
    })}
    {...props}
  />
);

export const Input = forwardRef(function input(
  { endAdornment, startAdornment, dataTestId, ...props }: IPropsInput,
  ref
) {
  return (
    <StyledInput
      inputRef={ref}
      {...props}
      InputProps={{
        startAdornment: startAdornment ? <InputAdornment position="start">{startAdornment}</InputAdornment> : null,
        endAdornment: endAdornment ? <InputAdornment position="end">{endAdornment}</InputAdornment> : null
      }}
      inputProps={{ 'data-testid': dataTestId }}
    />
  );
});

export default Input;
